import { render } from "./ClassItemBanner.vue?vue&type=template&id=56e6c383"
import script from "./ClassItemBanner.vue?vue&type=script&lang=js"
export * from "./ClassItemBanner.vue?vue&type=script&lang=js"
script.render = render

export default script